import { z } from 'zod';

export const getImpactAnswersDtoSchema_BuildingHeating = z.array(
  z.object({
    id: z.number(),
    userId: z.string(),
    projectId: z.number(),
    sector: z.string(),
    buildingHeatingType: z.string(),
    buildingSize: z.string(),
    numberOfMonthsOfUse: z.string(),
    isExternal: z.boolean(),
    label: z.string().nullable(),
    source: z.string().nullable(),
    score: z.number().optional(),
    tags: z
      .object({
        values: z
          .array(z.object({ id: z.number(), name: z.string() }))
          .optional(),
      })
      .optional(),
  }),
);

export type QuestionBuildingHeatingDto = {
  id: number;
  userId: string;
  projectId: number;
  sector: string;
  buildingHeatingType: string;
  buildingSize: string | number;
  numberOfMonthsOfUse: string | number;
  isExternal: boolean;
  label: string | null;
  source?: string | null;
  score?: number;
  tags?: { values?: Array<{ id: number; name: string }> };
};
